import { Skeleton } from '@mui/material';
import React from 'react';

const SkeletonGrid = () => (
    <div style={{ marginTop: '1rem', maxHeight: '100%', overflow: 'hidden', width: '100%' }}>
        <Skeleton animation="wave" height={45} style={{ margin: '0 0.625rem', marginBottom: '1.5625rem' }} />
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((el) => (
            <Skeleton key={el} animation="wave" height={35} style={{ margin: '0.625rem' }} />
        ))}
    </div>
);

export default SkeletonGrid;
